import React from "react";
import { FormViewer } from "@rankmi/all-in-one-components/lib/FormViewer";
import { FormRequisition } from "@rankmi/all-in-one-components/lib/FormRequisition";
import { DEFAULT_REQUISITION_ACTIVE_MODULES } from "@frontend/src/core/workflows/hiring_workflow_app_modules";
import { RequestProfile, RequestTypeSelector, RequestModal } from "@rankmi/workflows-app";
import { FormEmployeeRegistration } from "@rankmi/all-in-one-components/lib/FormEmployeeRegistration";
import { RegisterEmployeesForm } from "@rankmi/all-in-one-components/lib/RegisterEmployees";
import { FormOptionalSection } from "@rankmi/rankmi-optionals";

export const RequisitionFormViewer = ({
  showApproveButton,
  showCloseButton,
  showRejectButton,
  showDerivateButton,
  showSubmitButton,
  onCancel,
  onSubmit,
  onReject,
  onDeriveChanges,
  disabled,
  structure,
  entry,
  formTitle,
  type,
  hierarchyTypeId,
  isSubmittingForm,
  hierarchyCollaboratorTypeId,
}) => {
  return (
    <FormViewer
      showApproveButton={showApproveButton}
      isSubmittingForm={isSubmittingForm}
      showCloseButton={showCloseButton}
      showDerivateButton={showDerivateButton}
      showRejectButton={showRejectButton}
      showSubmitButton={showSubmitButton}
      onCancel={onCancel}
      onSubmit={onSubmit}
      onReject={onReject}
      onDeriveChanges={onDeriveChanges}
      disabled={disabled}
      structure={structure}
      entry={entry}
      formTitle={formTitle}
      type={type}
      hierarchyTypeId={hierarchyTypeId}
    />
  );
};

export const RequestProfileComponent = ({ workflowsId }) => {
  return (
    <RequestProfile
      id={workflowsId}
      registerRequisitionForm={RequisitionFormViewer}
      positionRequisitionForm={FormRequisition}
    />
  );
};


export const RequestTypeSelectorComponent = ({ id, onChange }) => {
  return (
    <RequestTypeSelector
      allowFetchAll
      activeModules={DEFAULT_REQUISITION_ACTIVE_MODULES}
      id={id}
      onChange={onChange}
    />
  );
};

// modal ver solicitud de ats
const PersonnelRegistrationFormViewer = ({
  type,
  dispatchUpdate,
  showApproveButton,
  showCloseButton,
  showRejectButton,
  showDerivateButton,
  showSubmitButton,
  onCancel,
  onSubmit,
  onReject,
  onDeriveChanges,
  disabled,
  entry,
  structure,
  optionalComponent
}) => {
  return (
    <FormEmployeeRegistration
      showApproveButton={showApproveButton}
      showCloseButton={showCloseButton}
      showDerivateButton={showDerivateButton}
      showRejectButton={showRejectButton}
      showSubmitButton={showSubmitButton}
      onCancel={onCancel}
      onSubmit={onSubmit}
      onReject={onReject}
      onDeriveChanges={onDeriveChanges}
      type={type}
      dispatchUpdate={dispatchUpdate}
      disabled={disabled}
      entry={entry}
      origin="ats"
      structure={structure}
      optionalComponent={optionalComponent}
    />
  )
}

/**
 * New component for RegisterEmployeesForm Viewer (Mexico)
 * @param {*} props 
 * @returns 
 */
const RegisterEmployeesFormViewer = (props) => {
  return (
    <RegisterEmployeesForm {...props} />
  )
}
export const RequestModalComponent = ({ id, isOpen, setIsOpen }) => {
  return (
    <RequestModal
      id={id}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      registerRequisitionForm={FormViewer}
      registerPersonnelRegistrationForm={
        PersonnelRegistrationFormViewer
      }
      registerEmployeesForm={RegisterEmployeesFormViewer}
      formOptional={FormOptionalSection}
    />
  );
};